<template>
  <div id="pageRoot">
    <div id="bg">
      <img src="/pages/img/sordoglo/svgGlo29bg.svg" />
      <p class="textBaseCourier" id="text01">ENCICLOPEDIA</p>
      <p class="textBaseCourier" id="text02">LOS SAPOS</p>
      <p class="textBaseCourier textSimple" id="text03">
        Hace muchos miles de años, los seres humanos vivían de forma muy
        diferente a la de ahora. Vivían en grupos, se desplazaban de un sitio a
        otro y se alimentaban de la caza, la pesca y la recolección de frutos.
      </p>

      <p class="textBaseCourier" id="text04">LOS SAPOS "CANTAN"</p>
      <p class="textBaseCourier textSimple" id="text05">
        Los sapos machos cantan en la primavera, que es la época del
        apareamiento. La principal función del canto es atraer a las hembras de
        su especie. Cada especie tiene su canto particular.
      </p>
    </div>
  </div>
</template>
<style scoped>
.textSimple {
  font-size: 22px;
  line-height: 33px;
  color: #000000;
}

#text01 {
  position: absolute;
  width: 402px;
  height: 78px;
  left: 227px;
  top: 70px;
  font-size: 51px;
  line-height: 55px;
  text-align: center;
  letter-spacing: 0.015em;
  color: #231f20;
}
#text02 {
  position: absolute;
  width: 429px;
  height: 51px;
  left: 64px;
  top: 169px;
  font-weight: bold;
  font-size: 47px;
  line-height: 53px;
  color: #231f20;
}
#text03 {
  position: absolute;
  width: 429px;
  height: 227px;
  left: 66px;
  top: 240px;
}
#text04 {
  position: absolute;
  width: 444px;
  height: 51px;
  left: 58px;
  top: 519px;
  font-weight: bold;
  font-size: 35px;
  line-height: 40px;
  color: #231f20;
}
#text05 {
  position: absolute;
  width: 850px;
  height: 198px;
  left: 58px;
  top: 573px;
}

#bg {
  position: absolute;
  left: 31px;
  top: 35px;
  z-index: 3;
  opacity: 0;
  animation-name: enciclopedia-appear;
  animation-duration: 1s;
  animation-delay: 0.3s;
  animation-timing-function: cubic-bezier(0, 0, 0.3, 1.3);
  animation-fill-mode: forwards;
}
@keyframes enciclopedia-appear {
  from {
    opacity: 0;
    top: 500px;
  }
  to {
    opacity: 1;
    top: 35px;
  }
}
</style>
<script>
export default {
  data() {
    return {
      videos: [
        "glo/Video 136.mp4",
        "glo/Video 137b.mp4",
        "glo/Video 138b.mp4",
        "glo/Video 138c.mp4",
      ]
    }
  }
}
</script>